import Button from '@/components/Button/Button';
import { ButtonVariants } from '@/components/Button/Button.types';
import Card from '@/components/Card/Card';
import Modal from '@/components/Modal/Modal';
import Table from '@/components/Tables/Table/Table';
import { StoreGroup } from '@/types/bundles.types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './DeactivateBundleModal.module.css';
import { CalendarAlert } from '@/utils/CalendarAlert/CalendarAlert';

interface DeactivateBundleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  groups: StoreGroup[];
  isLoading: boolean;
}

const DeactivateBundleModal: FC<DeactivateBundleModalProps> = ({ isOpen, onClose, onConfirm, groups, isLoading }) => {
  const { t } = useTranslation();

  return (
    <Modal
      className={styles.modal}
      headerContent={<div className={styles.header}>{t('editBundle.bundleSettings.deactivateModal.header')}</div>}
      showTitleDivider
      footerContent={
        <div className={styles.footer}>
          <div>
            {
              <CalendarAlert
                className={styles.calendarAlert}
                requestedVerbiage={false}
                warningIcon={true}
              ></CalendarAlert>
            }
            <div className={styles.footerButtons}>
              <Button onClick={onClose} variant={ButtonVariants.Secondary}>
                {t('common.cancel')}
              </Button>
              <Button onClick={onConfirm} isLoading={isLoading}>
                {t('common.confirm')}
              </Button>
            </div>
          </div>
        </div>
      }
      onClose={onClose}
      isOpen={isOpen}
      bodyContent={
        <div className={styles.body}>
          <p>{t('editBundle.bundleSettings.deactivateModal.deactivatingText')}</p>
          <Card className={styles.card}>
            <div className={styles.tableContainer}>
              <Table
                data={groups}
                columns={[{ accessorKey: 'groupName', header: t('editBundle.bundleSettings.table.storeGroup') }]}
                includeMinWidth={false}
              />
            </div>
          </Card>
        </div>
      }
    />
  );
};

export default DeactivateBundleModal;
